import React from 'react';
import '../styles/process.page.scss';
import { Container, Row, Col, Image } from 'react-bootstrap';
import PageTitle from '../components/PageTitle';

export default function CriteriaPage({l}) {
    return (
        <Container className="mb-5">
            <PageTitle title={l.pageTitle} />
            <Row className="mt-n3 pb-5">
                {l.criteriaItems.map((criteria, i) => renderCriteria(criteria, i))}
            </Row>
        </Container>
    )
}

function renderCriteria(criteria, i) {
    return (
        <Col xs={12} md={6} className="mt-1 mt-md-3" key={`criteria-${i}`}>
            <Row>
                <Col className="d-none d-lg-block" lg={2}>
                    <Image fluid src={criteria.iconSrc} alt={criteria.iconAlt} />
                </Col>
                <Col xs={12} lg={10}>
                    <div>
                        <span className="h4 bold">{criteria.title}</span>
                    </div>
                    <div>
                        <p dangerouslySetInnerHTML={{__html: criteria.text}}></p>
                    </div>
                </Col>
            </Row>
        </Col>
    )
}